import React from 'react';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, Bars3Icon } from '@heroicons/react/20/solid';
import { useDispatch } from 'react-redux';
import { logout } from '../../actions/auth';
import { Link, useNavigate } from 'react-router-dom';
import { EnergyblocksLogoIcon } from '../../components/icons/IconProvider';
//services
import { ConfigService } from '../../services';
import useWalletProvider from '../hooks/useWalletProvider';

const Header = () => {
  const { connectWallet, isWalletConnected, authWallet, disconnectWallet } =
    useWalletProvider();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logOut = async () => {
    dispatch(logout());
    await disconnectWallet();
    navigate('/login');
  };

  const walletDisconnect = () => {
    disconnectWallet();
  };

  const _sideBarOpen = () => {
    window.dispatchEvent(
      new CustomEvent('sideOpen', {
        detail: true,
      }),
    );
  };
  return (
    <>
      <div className="sticky top-0 pt-4 z-10 bg-white">
        <div>
          <span className="bg-[#A7D760]"></span>
          <span className="bg-[#3D4CB2]"></span>
          <span className="bg-[#9F9787]"></span>
          <span className="bg-[#E79853]"></span>
          <span className="bg-[#113B69]"></span>
        </div>
        <div className="bg-brandBlue p-3 rounded-lg mb-4 ">
          <div className="flex items-center justify-between">
            <div>
              <Link to={'/'}>
                <EnergyblocksLogoIcon />
              </Link>
              <div className="w-11 h-11 rounded-full flex items-center justify-center bg-white bg-opacity-5 md:hidden">
                <Bars3Icon
                  onClick={() => _sideBarOpen()}
                  className="h-5 w-5 text-white "
                  aria-hidden="true"
                />
              </div>
            </div>
            <div className="inline-flex items-center">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button
                    {...(!isWalletConnected && {
                      onClick: () => connectWallet(),
                    })}
                    className="btn-white-outline inline-flex w-full justify-center items-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-base font-semibold text-gray-900  "
                  >
                    {isWalletConnected
                      ? ConfigService.shortenAddress(
                          authWallet?.walletAddress,
                        ).toUpperCase()
                      : 'Connect Wallet'}
                    {isWalletConnected ? (
                      <ChevronDownIcon
                        className="-mr-1 h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    ) : (
                      ''
                    )}
                  </Menu.Button>
                </div>
                {isWalletConnected ? (
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="py-1">
                        <div className="px-4 py-2">
                          <button
                            onClick={() => walletDisconnect()}
                            className="bg-white text-brandRed w-full border border-brandRed px-4 py-3 text-sm font-medium"
                          >
                            Disconnect
                          </button>
                        </div>
                      </div>
                    </Menu.Items>
                  </Transition>
                ) : (
                  ''
                )}
              </Menu>

              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button className="inline-flex w-full justify-center items-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-900  ">
                    <div className="w-11 h-11 rounded-full overflow-hidden">
                      <img
                        src="/img/default-user-icon.png"
                        className="w-full h-full object-cover "
                        alt="Energyblocks Logo"
                      />
                    </div>
                    <ChevronDownIcon
                      className="-mr-1 h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      <Menu.Item>
                        <Link
                          to="/change-password"
                          className="block px-4 py-2 text-sm"
                        >
                          Change Password
                        </Link>
                      </Menu.Item>
                      <form method="POST" action="#">
                        <Menu.Item>
                          <button
                            type="submit"
                            onClick={() => logOut()}
                            className="block w-full px-4 py-2 text-left text-sm"
                          >
                            Sign out
                          </button>
                        </Menu.Item>
                      </form>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
